// extracted by mini-css-extract-plugin
export default {"AccountTypesPage":"AccountTypesPage_AccountTypesPage__XZPiv"};